/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDealerType,
  getUserNotificationSettings,
  updateOrderValidationEmailAddressesRequestSaga,
  updateOrderValidationEmailNotificationRequestSaga,
  updateOrderValidationNotificationRequestSaga,
} from 'domains/user';
import { NotificationSwitch } from 'pages/SettingsPage/NotificationCenter/NotificationUtils/NotificationSwitch';
import { SectionWrapper } from 'pages/SettingsPage/ProfilePage.styled';
import { Flex, Input, Text } from 'UI';

export const MyNetwork = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notificationSettings = useSelector(getUserNotificationSettings);
  const isR1 = useSelector(getDealerType) === 'R1';
  const handleSwitchOrderValidationChange = (enabled: boolean) => {
    dispatch(updateOrderValidationNotificationRequestSaga({ enabled }));
  };

  const handleSwitchOrderValidationEmailChange = (enabled: boolean) => {
    dispatch(updateOrderValidationEmailNotificationRequestSaga({ enabled }));
  };

  const emailAddressesInitialValue = (notificationSettings?.orderValidationNotificationEmailAddresses ?? []).join(', ');

  const handleEmailAddressesBlur = (value: string) => {
    const emailAddresses = value
      .split(',')
      .map((e) => e.trim())
      .filter(Boolean);
    dispatch(updateOrderValidationEmailAddressesRequestSaga({ emailAddresses }));
  };

  return isR1 ? (
    <SectionWrapper>
      <Flex direction={'column'} gap={15}>
        <Flex direction={'row'} justify={'space-between'} align={'center'} minWidth={100} gap={15}>
          <Flex direction={'column'}>
            <Text type="heading4">{t('settings.notification_center.my_network', 'My Network')}</Text>
            <Text type="base">
              {t('settings.notification_center.order_notify_receive', 'Receive notifications  ...')}
            </Text>
          </Flex>
        </Flex>
        <NotificationSwitch
          label={t(
            'settings.notification_center.my_network_order_waiting_validation',
            "When I have a Network's order waiting for validation",
          )}
          isEnabled={notificationSettings?.orderValidationNotificationEnabled ?? false}
          onChange={handleSwitchOrderValidationChange}
          data-cy={'toggle-notification-order-validation'}
        />
        <NotificationSwitch
          label={t(
            'settings.notification_center.my_network_order_validation_email',
            "Send an inbox Email when I have a Network's order waiting for validation",
          )}
          isEnabled={notificationSettings?.orderValidationEmailNotificationEnabled ?? false}
          onChange={handleSwitchOrderValidationEmailChange}
          data-cy={'toggle-notification-order-validation-email'}
        />
        <Text type="lg" bold>
          {t('settings.notification_center.my_network_email_address', 'Email Address')}*
        </Text>
        <Text type="sm" color="grey55">
          {t(
            'settings.notification_center.my_network_email_address_note',
            'You can add multiple recipients. Use commas to separate email addresses.',
          )}
        </Text>
        <Input
          name={'order_validation_email_notification_recipients'}
          bordered
          initialValue={emailAddressesInitialValue}
          onBlur={handleEmailAddressesBlur}
          data-cy={'input-order-validation-email-addresses'}
        />
      </Flex>
    </SectionWrapper>
  ) : (
    <></>
  );
};
